export const $_app_notifier = {
  methods: {
    $_toast (mes = 'Данная функция находится в разработке') {
      this.$notify({
        message: mes,
        timeout: 3000,
        icon: 'now-ui-icons ui-1_bell-53',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'danger'
      })
    },

    $_toast_dev () {
      this.$_toast('Данная функция находится в разработке')
    }
  }
}

